import { createAction, props } from '@ngrx/store';

export const storeEquipmentData = createAction(
  '[Equipment API] Store Equipment Data',
  props<{
    equipment: {
      details: {
        id: string;
        make: string;
        model: string;
        serialNumberRange: string;
        pvc?: string;
        equipmentCode: string;
      };
      resources: {
        title: string;
        url: string;
        downloadUrl?: string;
        s3Key?: string;
        providerResourceUrl?: string;
      }[];
      prompts: string[];
    };
  }>()
);

export const clearEquipmentData = createAction(
  '[Equipment API] Clear Equipment Data'
);

export const getEquipmentData = createAction(
  '[Equipment API] Get Equipment Data',
  props<{ equipment_code?: string }>()
);

